import { render, staticRenderFns } from "./ProductSaleInfo.vue?vue&type=template&id=4c8142cc&scoped=true"
import script from "./ProductSaleInfo.vue?vue&type=script&lang=js"
export * from "./ProductSaleInfo.vue?vue&type=script&lang=js"
import style0 from "./ProductSaleInfo.vue?vue&type=style&index=0&id=4c8142cc&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "4c8142cc",
  null
  
)

export default component.exports